export default __webpack_public_path__ + "static/media/head-purple.8022aa43.png";